export const gridColumnLayOut = [
  {
    dataField: "plantCd",
    headerText: "사업장",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "plantNm",
    headerText: "사업장",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "inspCd",
    headerText: "검수구분",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "inspCdNm",
    headerText: "검수구분",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "inspNo",
    headerText: "검수번호",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
    styleFunction: function (
      rowIndex,
      columnIndex,
      value,
      headerText,
      item,
      dataField
    ) {
      if (item.updateYn === "N") {
        return "my-row-style";
      }

      return "my-custom-down";
    },
  },
  {
    dataField: "vndrCd",
    headerText: "공급업체",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "vndrNm",
    headerText: "공급업체",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "rvndrCd",
    headerText: "실공급업체",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "rvndrNm",
    headerText: "실공급업체",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "vhclNo",
    headerText: "차량번호",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },

  {
    dataField: "scrapAreaCd",
    headerText: "하차지",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "scrapAreaCdNm",
    headerText: "하차지",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "inWeight",
    headerText: "입차중량",
    dataType: "numeric",
    formatString: "#,##0",
    style: "my-custom-right",
    editable: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "outWeight",
    headerText: "출차중량",
    dataType: "numeric",
    formatString: "#,##0",
    style: "my-custom-right",
    editable: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "realWeight",
    headerText: "입고중량",
    dataType: "numeric",
    formatString: "#,##0",
    style: "my-custom-right",
    editable: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },

  {
    dataField: "itemCd",
    headerText: "사전등급",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "itemNm",
    headerText: "사전등급",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "inspItemCd",
    headerText: "검수등급",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "inspItemNm",
    headerText: "검수등급",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "dcsnItemCd",
    headerText: "확정등급",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "dcsnItemNm",
    headerText: "확정등급",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },

  {
    dataField: "workerNm",
    headerText: "검수자",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },

  {
    headerText: "세부등급1",
    children: [
      {
        dataField: "subItemCd1",
        headerText: "등급",
        visible: false,
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
      {
        dataField: "subItemNm1",
        headerText: "등급",
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
      {
        dataField: "subItemPrdCd1",
        headerText: "품목",
        visible: false,
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
      {
        dataField: "subItemPrdNm1",
        headerText: "품목",
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
      {
        dataField: "subItemRate1",
        headerText: "비율",
        visible: false,
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
      {
        dataField: "subItemRateNm1",
        headerText: "비율",
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
    ],
  },
  {
    headerText: "세부등급2",
    children: [
      {
        dataField: "subItemCd2",
        headerText: "등급",
        visible: false,
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
      {
        dataField: "subItemNm2",
        headerText: "등급",
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
      {
        dataField: "subItemPrdCd2",
        headerText: "품목",
        visible: false,
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
      {
        dataField: "subItemPrdNm2",
        headerText: "품목",
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
      {
        dataField: "subItemRate2",
        headerText: "비율",
        visible: false,
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
      {
        dataField: "subItemRateNm2",
        headerText: "비율",
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
    ],
  },
  {
    headerText: "세부등급3",
    children: [
      {
        dataField: "subItemCd3",
        headerText: "등급",
        visible: false,
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
      {
        dataField: "subItemNm3",
        headerText: "등급",
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
      {
        dataField: "subItemPrdCd3",
        headerText: "품목",
        visible: false,
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
      {
        dataField: "subItemPrdNm3",
        headerText: "품목",
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
      {
        dataField: "subItemRate3",
        headerText: "비율",
        visible: false,
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
      {
        dataField: "subItemRateNm3",
        headerText: "비율",
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
    ],
  },
  {
    headerText: "기타등급",
    children: [
      {
        dataField: "etcItemCd",
        headerText: "등급",
        visible: false,
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
      {
        dataField: "etcItemNm",
        headerText: "등급",
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
      {
        dataField: "etcItemPrdCd",
        headerText: "품목",
        visible: false,
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
      {
        dataField: "etcItemPrdNm",
        headerText: "품목",
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
      {
        dataField: "etcItemRate",
        headerText: "비율",
        visible: false,
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
      {
        dataField: "etcItemRateNm",
        headerText: "비율",
        filter: {
          showIcon: true,
          useExMenu: true,
        },
      },
    ],
  },
  {
    dataField: "outageWght",
    headerText: "감량",
    dataType: "numeric",
    formatString: "#,##0",
    style: "my-custom-right",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "outageCd",
    headerText: "사유",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "outageRsn",
    headerText: "감량사유",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "outageRsnNm",
    headerText: "감량사유",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "returnCd",
    headerText: "반품/경고",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "returnCdNm",
    headerText: "반품/경고",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "returnRsn",
    headerText: "사유",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "returnRsnNm",
    headerText: "반품사유",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "dprctCd",
    headerText: "감가내역",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "dprctCdNm",
    headerText: "감가내역",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "dprctRate",
    headerText: "감가비율",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "dprctRateNm",
    headerText: "감가비율",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "totalWeight",
    headerText: "총중량",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "inptDt",
    headerText: "입고일자",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },

  {
    dataField: "inptDt",
    headerText: "입차시간",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },

  {
    dataField: "tmsOdrNo",
    headerText: "배차번호",
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "updateYn",
    headerText: "검수확정취소 여부",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
  {
    dataField: "inptDt",
    headerText: "입고일자",
    visible: false,
    filter: {
      showIcon: true,
      useExMenu: true,
    },
  },
];
